import { Injectable } from '@angular/core';
import { BaseServiceWithFilter } from './base.service';
import { BaseFilterModel } from '@cl/shared/models/base/base-filter-model.model';
import { HttpClient } from '@angular/common/http';
import { ExpenseRequestType } from '@cl/shared/models/expense-requests/expense-request-type.model';

@Injectable({
    providedIn: 'root',
})
export class ExpenseRequestTypesService extends BaseServiceWithFilter<ExpenseRequestType, BaseFilterModel> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/expense-request-types/');
    }
}
